import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import WebFont from 'webfontloader';
import { Amplify, Auth } from 'aws-amplify';
import { ThemeProvider as ThemeProviderV5 } from '@mui/material/styles';
import awsconfig from './services/Amplify/aws-exports';
import { AccountProvider } from './contexts/Account';
import Router from './Router';
import storage from './storage';
import { ACTheme as ACThemeV5 } from './themes';
import CssBaselineV5 from '@mui/material/CssBaseline';
import { RecurlyProvider, Elements } from '@recurly/react-recurly';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { loadUsetifulScript } from 'usetiful-sdk';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { initializeGTM } from './services/GTM';

WebFont.load({
  google: {
    families: ['Poppins:300,400,500,600,700,800,900'],
  },
});
Amplify.configure(awsconfig);
Auth.configure({
  storage,
});

function App() {
  useEffect(() => {
    console.log('load Usetiful script');
    loadUsetifulScript('aa8250b98cf7216057ef56741867d18b');
    console.log(
      'process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY',
      process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY
    );

    initializeGTM();
  }, []);

  return (
    <ThemeProviderV5 theme={ACThemeV5}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CALENDAR}>
        <RecurlyProvider publicKey={process.env.REACT_APP_RECURLY_PUBLIC_KEY}>
          <GoogleReCaptchaProvider
            reCaptchaKey={process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY || '6LcTklQfAAAAAPQ4twz5MuYmNtFH188jGaifOnPm'}
            scriptProps={{ async: true, defer: true, appendTo: 'head' }}
          >
            <Elements>
              <style>
                {`
                .grecaptcha-badge {
                  visibility: hidden;
                }
              `}
              </style>
              <CssBaselineV5 />
              <AccountProvider>
                <Helmet
                  defaultTitle={process.env.REACT_APP_APPLICATION_NAME}
                  titleTemplate={
                    process.env.REACT_APP_APPLICATION_TITLE_TEMPLATE
                  }
                />
                <BrowserRouter>
                  <Router />
                </BrowserRouter>
              </AccountProvider>
            </Elements>
          </GoogleReCaptchaProvider>
        </RecurlyProvider>
      </GoogleOAuthProvider>
    </ThemeProviderV5>
  );
}

export default App;
